import registrationInstance from '../instance'

const getExpertCartSetting = (module, businessScope) => {
  return registrationInstance.get(`/company/expert/cartSetting/${module}/${businessScope}`)
}

export default getExpertCartSetting
